/**
 * Connection states enumeration
 */
export const ConnectionState = Object.freeze({
  CONNECTING: 1,
  CONNECTED: 2,
  RECONNECTING: 3,
  DISCONNECTING: 4,
  DISCONNECTED: 5,
});